import { gql } from '@apollo/client';

export const FETCH_FUNNEL_BILLING_EXPERIENCE = gql`
  query Flex_FetchFunnelBillingExperience($input: FunnelBillingExperienceConfigurationInput!) {
    funnelBillingExperienceConfiguration(input: $input) {
      id
      funnelBillingExperience
    }
  }
`;
